import React, { Component } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';

import Analytics from 'APP_ROOT/services/analytics';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import Events from '../../common/events';
import { strings } from 'APP_ROOT/localization';
import recurlyOptions from './recurlyOptions';
import { string } from 'prop-types';

export default class EditBillingModal extends Component {

    constructor(props) {

        super(props);
        this.state = {
            setBillingMessage: null
        };
    }

    afterEditBillingModalOpened = (e) => {
        Analytics.modalView('/editBillingModal');
        document.documentElement.classList.add("no-scroll");
        if(window.recurly)
        {
            window.recurly.configure(recurlyOptions);
        }
    }

    onEditBillingSubmit = (e) => {

        //modify billing info
        e.preventDefault();
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: string.billing_updating_billing_information } }));
        var form = e.target;
        if(window.recurly)
        {
            window.recurly.token(form, (err, token) => {
                if (err) {
                    console.error(err);
                    this.onEditBillingFail(err);
                } else {
                    console.log(token);
                    LambdaUtil.updateAccountBillingInformation(this.props.user.stage, token.id, this.onEditBillingSuccess, this.onEditBillingFail);
                }
            });
        }
        else
        {
            this.onEditBillingFail(strings.billing_unable_to_load_billing_information);
        }
    }

    onEditBillingSuccess = (data) => {

        console.log(data);
        var payload = JSON.parse(data.Payload);
        if (payload && payload.status && payload.status === "ERROR") {
            var message = payload && payload.message ? //TODO LOC BILLING
                payload.message :
                strings.billing_an_unknown_error_trying_to_save;
            this.setState({ setBillingMessage: message }, () => { document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE)); });
        } else {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.billing_successfully_updated_your_billing_information, style: 'success', override: "true" } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }

    onEditBillingFail = (err) => {

        console.error(err);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        var message = err && err.message ? err.message : strings.billing_an_unknown_error_trying_to_save; //TODO LOC BILLING
        this.setState({ setBillingMessage: message });
    }

    render() {

        var errorMessage = this.state.setBillingMessage ?
            <p className="error-message"><i className="material-icons">error_outline</i>{this.state.setBillingMessage}</p> :
            null

        return (
            <Modal isOpen={this.props.isOpen}
                contentLabel="edit-billing-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.closeEditBillingModal}
                onAfterOpen={this.afterEditBillingModalOpened}>
                <div className="container-fluid form-card">

                    <div className="row">

                        <div className="col-12 content-group">
                            <form className="edit-billing-form row" onSubmit={this.onEditBillingSubmit}>

                                <div className="col-12 form-section">

                                    <h2><i className="material-icons">payment</i> {strings.billing_action_edit_payment_information}</h2>

                                    {/*noBillingMessage*/}

                                    <h3>{strings.billing_credit_card_information_title}</h3>

                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="recurly-number">{strings.billing_credit_card_number_label}</label>
                                            <div data-recurly="number" id="recurly-number"></div>
                                        </div>

                                        <div className="col-4 col-sm-3">
                                            <label htmlFor="recurly-cvv">{strings.billing_cvv}</label>
                                            <div data-recurly="cvv" id="recurly-cvv"></div>
                                        </div>

                                        <div className="col-12 d-md-none d-lg-none d-xl-none"></div>

                                        <div className="col-4 col-md-3">
                                            <label htmlFor="recurly-month">{strings.billing_expiry_month_label}</label>
                                            <div data-recurly="month" id="recurly-month"></div>
                                        </div>

                                        <div className="col-12 d-sm-none d-md-none d-lg-none d-xl-none"></div>

                                        <div className="col-8 col-md-3">
                                            <label htmlFor="recurly-number">{strings.billing_expiry_year_label}</label>
                                            <div data-recurly="year" id="recurly-year"></div>
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="first-name">{strings.billing_first_name_label}</label>
                                            <input id="first-name" type="text" data-recurly="first_name" placeholder="Jane" />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="last-name">{strings.billing_last_name_label}</label>
                                            <input type="text" data-recurly="last_name" placeholder="Doe" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 form-section">

                                    <h3>{strings.billing_billing_address_title}</h3>

                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="address1">{strings.billing_address_line_1_label}</label>
                                            <input id="address1" type="text" data-recurly="address1" placeholder="123 Raven rd." />
                                            <label htmlFor="address2">{strings.billing_address_line_2_label}</label>
                                            <input id="address2" type="text" data-recurly="address2" />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="city" >{strings.billing_address_city_label}</label>
                                            <input id="city" type="text" data-recurly="city" placeholder="Ottawa" />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="postal_code">{strings.billing_zip_postal_code_label}</label>
                                            <input id="postal_code" type="text" data-recurly="postal_code" placeholder="12345/A1A1A1" />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="country">{strings.billing_country_label}</label>
                                            <CountrySelect id="country" placeholder="Canada" />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <label htmlFor="state">{strings.billing_state_province_label}</label>
                                            <input id="state" type="text" data-recurly="state" placeholder="Ontario" />
                                        </div>

                                        <input type="hidden" name="recurly-token" data-recurly="token" />
                                    </div>
                                </div>

                                <div className="col-12 action-btns">
                                    <button className="btn btn-outline-blue" onClick={this.props.closeEditBillingModal}><i className="material-icons">close</i>{strings.action_cancel}</button>
                                    <button className="btn"><i className="material-icons">check</i>{strings.action_save}</button>
                                    {errorMessage}
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </Modal>
        );
    }
}

const COUNTRY_OPTIONS = [
    { value: 'US', label: 'USA' },
    { value: 'CA', label: 'Canada' },
    { value: 'MX', label: 'Mexico' },
];

/**
 * CountrySelect is purpose-built for the recurly form.
 * It adds a hidden input with data-recurly='country' so that
 * whatever the user chooses in the select will be submitted
 * with the form.
 * Note: We tried to use inputProps={{'data-recurly':'country'}}
 * On the Select component and it does not work because the
 * input maintained by Select is just for keyboard input and does
 * not hold the actual selected value.
 **/
class CountrySelect extends React.PureComponent {
    state = {
        selectedOption: '',
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    }

    render(){
        const { selectedOption } = this.state;
        const value = selectedOption && selectedOption.value;
        return (
            <React.Fragment>
                <Select
                    {...this.props}
                    id='country'
                    options={COUNTRY_OPTIONS}
                    onChange={this.handleChange}
                    value={selectedOption}
                    matchProp='label'
                />
                <input type='hidden' value={value} data-recurly='country' />
            </React.Fragment>
        );
    }
}
